import { locales } from "../constants/locales";

export const formatCurrencyConverter = (
    amount: number | undefined,
    currency?: string | undefined,
    fixedDecimalCount?: number,
    type?: string
): string => {
    if (!amount) return "";
    if (amount < 0) return "0";
    if (!currency) {
        if (type === "tourTicket") {
            return `
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center'
        }}>
          <i style={{
            marginRight: '4px',
            fontSize: '10px',
            transform: "translateY(0.5px)"
          }} className="icon-ticket" />
          <span>${String(amount)}</span>
        </div>
      `;
        }
        return String(amount);
    }
    if (currency === 'FPP' || currency === 'GOS') return String(new Intl.NumberFormat().format(amount));

    let formattedAmount = "";
    let suffix = "";

    if (amount >= 1000000) {
        formattedAmount = (Math.floor((amount / 1000000) * 100) / 100).toFixed(2);
        suffix = " M";
    } else if (amount >= 10000) {
        formattedAmount = (Math.floor((amount / 1000) * 100) / 100).toFixed(2);
        suffix = " K";
    } else {
        formattedAmount = amount.toFixed(fixedDecimalCount ? fixedDecimalCount : 2);
    }

    const formatter = new Intl.NumberFormat(locales?.[currency] ?? "en-EN", {
        style: "currency",
        currency: currency!,
        minimumFractionDigits: fixedDecimalCount ? fixedDecimalCount : 2,
});

    const formattedNumber = formatter.format(Number(formattedAmount));

    return `${formattedNumber}${suffix}`;
};
